import { get, post, put, del } from "./http";
import { dataToJson } from "./util";

/** API URL을 반환 */
export function getApiUrl(url) {
  return "/api" + url;
}

export function getApi(url) {
  return get(getApiUrl(url));
}

export function postApi(url, param) {
  return post(getApiUrl(url), dataToJson(param));
}

export function putApi(url, param) {
  return put(getApiUrl(url), dataToJson(param));
}

export function delApi(url, param) {
  return del(getApiUrl(url), dataToJson(param));
}

export default {
  /** 로그인 처리 */
  doLogin(param) {
    return postApi("/login", param);
  },
  logout() {
    return getApi("/login/out");
  },
  /** 거래처 리스트 */
  listCustomer() {
    return getApi("/customer");
  },
  /** 거래처 등록 */
  createCustomer(param) {
    return postApi("/customer", param);
  },
  /** 거래처 수정 */
  updateCustomer(param) {
    return putApi("/customer/" + param.id, param);
  },
  /** 거래처 삭제 */
  deleteCustomer(param) {
    return delApi("/customer/" + param.id);
  },
  /** 거래처 매출/매입 정보 삭제 */
  deleteCustomerAll(param) {
    return delApi("/customer/all/" + param.id);
  },
  updateCustomerBulk(param) {
    return putApi("/customer/bulk", param);
  },
  listCustomerLevel() {
    return getApi("/customer/level");
  },
  createCustomerLevel(param) {
    return postApi("/customer/level", param);
  },
  updateCustomerLevel(param) {
    return putApi("/customer/level/" + param.id, param);
  },
  deleteCustomerLevel(param) {
    return delApi("/customer/level/" + param.id);
  },
  listClientLevel() {
    return getApi("/customer/client_level");
  },
  createClientLevel(param) {
    return postApi("/customer/client_level", param);
  },
  updateClientLevel(param) {
    return putApi("/customer/client_level/" + param.id, param);
  },
  deleteClientLevel(param) {
    return delApi("/customer/client_level/" + param.id);
  },
  listCustomerGlassLevel() {
    return getApi("/customer/glass_level");
  },
  createCustomerGlassLevel(param) {
    return postApi("/customer/glass_level", param);
  },
  updateCustomerGlassLevel(param) {
    return putApi("/customer/glass_level/" + param.id, param);
  },
  deleteCustomerGlassLevel(param) {
    return delApi("/customer/glass_level/" + param.id);
  },
  listCustomerDoorLevel() {
    return getApi("/customer/door_level");
  },
  createCustomerDoorLevel(param) {
    return postApi("/customer/door_level", param);
  },
  updateCustomerDoorLevel(param) {
    return putApi("/customer/door_level/" + param.id, param);
  },
  deleteCustomerDoorLevel(param) {
    return delApi("/customer/door_level/" + param.id);
  },
  checkCustomerCrn(param) {
    return postApi("/customer/check_crn/" + param.id, param);
  },
  /** 제품 리스트 */
  listProduct() {
    return getApi("/product");
  },
  /** 제품 리스트 */
  selectProduct(id) {
    return getApi("/product/" + id);
  },
  /** 제품 프로세스 등록 */
  createProductProcess(param) {
    return postApi("/product/process", param);
  },
  deleteProductProcess(param) {
    return delApi("/product/process/" + param.id);
  },
  /** BOM 하위 품목 재고 관리 설정 */
  updateSubItemManageStock(param) {
    return putApi("/product/sub/" + param.id, param);
  },
  /** 제품 등록 */
  createProduct(param) {
    return postApi("/product", param);
  },
  /** 제품 수정 */
  updateProduct(param) {
    return putApi("/product/" + param.id, param);
  },
  deleteProduct(param) {
    return delApi("/product/" + param.id);
  },
  updateProductBulk(param) {
    return putApi("/product/bulk", param);
  },
  deleteProductBulk(param) {
    return postApi("/product/delete", param);
  },
  listBOM() {
    return getApi("/bom");
  },
  selectBOM(id) {
    return getApi("/bom/" + id);
  },
  listBOMs(param) {
    return putApi("/bom", param);
  },
  registerBOM(param) {
    return putApi("/bom/" + param.product_id, param);
  },
  deleteBOM(param) {
    return delApi("/bom/" + param.product_id);
  },
  listBOMAssemble(param) {
    return getApi("/bom/assemble/" + param.id);
  },
  listBOMTree(id) {
    return getApi("/bom/tree/" + id);
  },
  /** 견적 리스트 */
  listEstimation(period) {
    return getApi("/estimation/" + period.startDate + "/" + period.endDate);
  },
  /** 견적 등록 */
  createEstimation(param) {
    return postApi("/estimation", param);
  },
  /** 견적 수정 */
  updateEstimation(param) {
    return putApi("/estimation/" + param.id, param);
  },
  /** 견적 삭제 */
  deleteEstimation(param) {
    return delApi("/estimation/" + param.id);
  },
  /** 견적 리스트 */
  listUser() {
    return getApi("/user");
  },
  /** inbound */
  listInboundOrder(period) {
    return getApi("/inbound/order/" + period.startDate + "/" + period.endDate);
  },
  listInbound(period) {
    return getApi("/inbound/" + period.startDate + "/" + period.endDate);
  },
  registerInbound(param) {
    return postApi("/inbound/register", param);
  },
  createInbound(param) {
    return postApi("/inbound", param);
  },
  updateInbound(param) {
    return putApi("/inbound/" + param.id, param);
  },
  updateInboundAmount(param) {
    return putApi("/inbound/amount/" + param.id, param);
  },
  deleteInbound(param) {
    return postApi("/inbound/delete", param);
  },
  /** 입고 단위 입고 취소: 선택한 입고 id만 취소 */
  deleteInboundItems(ids) {
    return postApi("/inbound/delete-items", ids);
  },
  statInboundBill(period) {
    return getApi("/inbound/bill/" + period.startDate + "/" + period.endDate);
  },
  listInboundBill(id) {
    return getApi("/inbound/bill/" + id);
  },
  listInboundDetail(period, param) {
    return putApi(
      "/inbound/detail/" + period.startDate + "/" + period.endDate,
      param,
    );
  },
  updateInboundBulk(param) {
    return putApi("/inbound/bulk", param);
  },
  statInboundSettlement(period) {
    return getApi("/inbound/settlement/" + period.year + "/" + period.month);
  },
  listBill(param) {
    return getApi("/bill/" + param);
  },
  cancelBill(param) {
    return postApi("/bill/delete", param);
  },
  createBill(param) {
    return postApi("/bill", param);
  },
  updateBill(param) {
    return putApi("/bill/" + param.id, param);
  },
  deleteBill(param) {
    return delApi("/bill/" + param.id);
  },
  /** 사용자 등록 */
  createUser(param) {
    return postApi("/user", param);
  },
  updateUser(param) {
    return putApi("/user/" + param.id, param);
  },
  deleteUser(param) {
    return delApi("/user/" + param.id, param);
  },
  updateUserPassword(param) {
    return postApi("/user/password", param);
  },
  resetPassword(param) {
    return postApi("/user/reset_password", param);
  },
  listUserConfig(id) {
    return getApi("/user/config/" + id);
  },
  /** 제품 상세 구분 리스트 */
  listProductCategory() {
    return getApi("/product/category");
  },
  createProductCategory(param) {
    return postApi("/product/category", param);
  },
  updateProductCategory(param) {
    return putApi("/product/category/" + param.id, param);
  },
  updateProductCategoryStatFlagAll(param) {
    return postApi("/product/category/stat_flag_all", param);
  },
  deleteProductCategory(param) {
    return delApi("/product/category/" + param.id);
  },
  /** 제품 판매구분 리스트 */
  listSaleType() {
    return getApi("/sale_type");
  },
  /** 제품 구분 리스트 */
  listProductType() {
    return getApi("/product/type");
  },
  createProductType(param) {
    return postApi("/product/type", param);
  },
  updateProductType(param) {
    return putApi("/product/type/" + param.id, param);
  },
  deleteProductType(param) {
    return delApi("/product/type/" + param.id);
  },
  listUnit() {
    return getApi("/unit");
  },
  listProductPrice() {
    return getApi("/product/price");
  },
  saveProductPrice(param) {
    return postApi("/product/price", param);
  },
  saveProductPriceByExcel(param) {
    return postApi("/product/price_excel", param);
  },
  saveProductGlassPriceByExcel(param) {
    return postApi("/product/price_glass_excel", param);
  },
  saveProductDoorPriceByExcel(param) {
    return postApi("/product/price_door_excel", param);
  },
  deleteProductPrice(param) {
    return delApi("/product/price/" + param.id);
  },
  listProductDoorPrice() {
    return getApi("/product/door_price");
  },
  saveProductDoorPrice(param) {
    return postApi("/product/door_price", param);
  },
  deleteProductDoorPrice(param) {
    return delApi("/product/door_price/" + param.id);
  },
  listProductDoorColorPrice() {
    return getApi("/product/door_color_price");
  },
  saveProductDoorColorPrice(param) {
    return postApi("/product/door_color_price", param);
  },
  deleteProductDoorColorPrice(param) {
    return delApi("/product/door_color_price/" + param.id);
  },
  registerProductGlass(param) {
    return postApi("/product/glass", param);
  },
  deleteProductGlass(param) {
    return delApi("/product/glass/" + param.id);
  },
  listProductGlassPrice() {
    return getApi("/product/glass_price");
  },
  saveProductGlassPrice(param) {
    return postApi("/product/glass_price", param);
  },
  deleteProductGlassPrice(param) {
    return delApi("/product/glass_price/" + param.id);
  },
  registerProductDoor(param) {
    return postApi("/product/door", param);
  },
  deleteProductDoor(param) {
    return delApi("/product/door/" + param.id);
  },
  registerProductDoorColorPrice(param) {
    return postApi("/product/door_color_price", param);
  },
  listProductStock(param) {
    return getApi(
      "/product/stock/" + param.product_id + "/" + param.piece_productname,
    );
  },
  deleteProductStock(param) {
    return postApi("/product/stock", param);
  },
  updateSafetyStock(param) {
    return postApi("/product/stock/safety", param);
  },
  listProduction(period) {
    return getApi("/production/" + period.startDate + "/" + period.endDate);
  },
  listProductionContract(param) {
    return getApi("/production/contract/" + param.id);
  },
  listProductionContractPeriod(period) {
    return getApi(
      "/production/contract/" + period.startDate + "/" + period.endDate,
    );
  },
  // selectProductionContractDetail(id) {
  //   return getApi('/production/contract_detail/' + id)
  // },
  registerProduction(param) {
    return postApi("/production/register", param);
  },
  createProduction(param) {
    return postApi("/production", param);
  },
  /** history */
  listHistory(period) {
    return getApi("/history/" + period.startDate + "/" + period.endDate);
  },
  listAllProductProcess() {
    return getApi("/product/process");
  },
  listUserGroup() {
    return getApi("/user_group");
  },
  createUserGroup(param) {
    return postApi("/user_group", param);
  },
  updateUserGroup(param) {
    return putApi("/user_group/" + param.id, param);
  },
  deleteUserGroup(param) {
    return delApi("/user_group/" + param.id);
  },
  listUserAuthority() {
    return getApi("/user_authority");
  },
  listTask() {
    return getApi("/task");
  },
  createTask(param) {
    return postApi("/task", param);
  },
  updateTask(param) {
    return putApi("/task/" + param.id, param);
  },
  deleteTask(param) {
    return delApi("/task/" + param.id);
  },
  listProcess() {
    return getApi("/process");
  },
  createProcess(param) {
    return postApi("/process", param);
  },
  updateProcess(param) {
    return putApi("/process/" + param.id, param);
  },
  deleteProcess(param) {
    return delApi("/process/" + param.id);
  },
  /** 코드 리스트 */
  listCode() {
    return getApi("/code");
  },
  /** 코드 생성규칙 저장 */
  updateCode(param) {
    return putApi("/code/" + param.id, param);
  },
  /* 수주 리스트 */
  listContract(period) {
    return getApi("/contract/" + period.startDate + "/" + period.endDate);
  },
  listContractCancel(period) {
    return getApi(
      "/contract/cancel/" + period.startDate + "/" + period.endDate,
    );
  },
  listContractNonSale(period) {
    return getApi(
      "/contract/non_sale/" + period.startDate + "/" + period.endDate,
    );
  },
  selectContract(id) {
    return getApi("/contract/" + id);
  },
  listContractDetail(period, param) {
    return postApi(
      "/contract/detail/" + period.startDate + "/" + period.endDate,
      param,
    );
  },
  selectContractDeteail(id) {
    return getApi("/contract/detail/" + id);
  },
  selectContractByService(id) {
    return getApi("/contract/service/" + id);
  },
  createContract(param) {
    return postApi("/contract", param);
  },
  updateContract(param) {
    return putApi("/contract/" + param.id, param);
  },
  deleteContract(param) {
    return delApi("/contract/" + param.id);
  },
  listContractHistory(customer_id, product_id) {
    return getApi("/contract/history/" + customer_id + "/" + product_id);
  },
  listContractPackage(period) {
    return getApi(
      "/contract/package/" + period.startDate + "/" + period.endDate,
    );
  },
  updateContractPackageCheck(param) {
    return putApi("/contract/package/check/" + param.id, param);
  },
  updateContractPackageFinish(param) {
    return putApi("/contract/package/finish/" + param.id, param);
  },
  updateContractPackageCancel(param) {
    return putApi("/contract/package/cancel/" + param.id, param);
  },
  listContractShipment(period) {
    return getApi(
      "/contract/shipment/" + period.startDate + "/" + period.endDate,
    );
  },
  updateContractShipmentFinish(param) {
    return postApi("/contract/shipment/finish", param);
  },
  updateContractShipmentFinishById(param) {
    return getApi("/contract/shipment/finish/" + param.id);
  },
  updateContractShipmentCancel(param) {
    return postApi("/contract/shipment/cancel", param);
  },
  updateContractDetail(param) {
    return putApi("/contract/detail/" + param.id, param);
  },
  selectContractGood(code) {
    return getApi("/contract/good/" + code);
  },
  getOptionCost(param) {
    return postApi("/contract/cost", param);
  },
  listContractDetailExcel(period) {
    return getApi("/contract/excel/" + period.startDate + "/" + period.endDate);
  },
  listSale(period) {
    return getApi("/sale/" + period.startDate + "/" + period.endDate);
  },
  registerSale(param) {
    return postApi("/sale/register", param);
  },
  updateSale(param) {
    return putApi("/sale/" + param.id, param);
  },
  updateSaleBulk(param) {
    return putApi("/sale/bulk", param);
  },
  deleteSale(param) {
    return postApi("/sale/delete", param);
  },
  createSale(param) {
    return postApi("/sale", param);
  },
  listSaleCustomer(customer_id, period) {
    return getApi(
      "/sale/customer/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  listSaleContract(period) {
    return getApi("/sale/contract/" + period.startDate + "/" + period.endDate);
  },
  listSaleDetail(period, param) {
    return putApi(
      "/sale/detail/" + period.startDate + "/" + period.endDate,
      param,
    );
  },
  listSaleInvoice(id) {
    return getApi("/sale/invoice/" + id);
  },
  statSaleSettlement(period) {
    return getApi("/sale/settlement/" + period.year + "/" + period.month);
  },
  listCompany() {
    return getApi("/company");
  },
  listCollectByCustomer(customer_id, period) {
    return getApi(
      "/collect/customer/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  listCollectInome(customer_id, period) {
    return getApi(
      "/collect/income/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  listCollectSum(period) {
    return getApi("/collect/sum/" + period.startDate + "/" + period.endDate);
  },
  listCollectStat(period) {
    return getApi("/collect/stat/" + period.startDate + "/" + period.endDate);
  },
  createCollect(param) {
    return postApi("/collect", param);
  },
  updateCollect(param) {
    return putApi("/collect/" + param.id, param);
  },
  deleteCollect(param) {
    return delApi("/collect/" + param.id);
  },
  listCollectService(id) {
    return getApi("/collect/service/" + id);
  },
  listPay(customer_id, period) {
    return getApi(
      "/pay/" + customer_id + "/" + period.startDate + "/" + period.endDate,
    );
  },
  listPayExpense(customer_id, period) {
    return getApi(
      "/pay/expense/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  createPay(param) {
    return postApi("/pay", param);
  },
  updatePay(param) {
    return putApi("/pay/" + param.id, param);
  },
  deletePay(param) {
    return delApi("/pay/" + param.id);
  },
  listPaySum(period) {
    return getApi("/pay/sum/" + period.startDate + "/" + period.endDate);
  },
  listPayStat(period) {
    return getApi("/pay/stat/" + period.startDate + "/" + period.endDate);
  },
  listInvoice(period) {
    return getApi("/invoice/" + period.startDate + "/" + period.endDate);
  },
  listInvoiceByCustomer(customer_id, period) {
    return getApi(
      "/invoice/customer/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  createInvoice(param) {
    return postApi("/invoice", param);
  },
  updateInvoice(param) {
    return putApi("/invoice/" + param.id, param);
  },
  deleteInvoice(param) {
    return delApi("/invoice/" + param.id);
  },
  cancelInvoice(param) {
    return postApi("/invoice/delete", param);
  },
  listOrder(period) {
    //발주 리스트
    return getApi("/order/" + period.startDate + "/" + period.endDate);
  },
  listOrderDetail(period, param) {
    return postApi(
      "/order/detail/" + period.startDate + "/" + period.endDate,
      param,
    );
  },
  selectOrder(id) {
    return getApi("/order/" + id);
  },
  createOrder(param) {
    return postApi("/order", param);
  },
  updateOrder(param) {
    return putApi("/order/" + param.id, param);
  },
  deleteOrder(param) {
    return delApi("/order/" + param.id);
  },
  listStock(param) {
    return getApi(
      "/stock/" +
        param.startDate +
        "/" +
        param.endDate +
        "/" +
        param.piece_productname +
        "?product_id=" +
        encodeURIComponent(param.product_id),
    );
  },
  createStcok(param) {
    return postApi("/stock", param);
  },
  createStcokByExcel(param) {
    return postApi("/stock/excel", param);
  },
  createStockSetBreak(param) {
    return postApi("/stock/set_break", param);
  },
  updateStock(param) {
    return putApi("/stock/" + param.id, param);
  },
  deleteStcok(param) {
    return delApi("/stock/" + param.id);
  },
  listInboundStock(period) {
    return getApi("/stock/inbound/" + period.startDate + "/" + period.endDate);
  },
  listService(period) {
    return getApi("/service/" + period.startDate + "/" + period.endDate);
  },
  listServiceBySearchWord(period, param) {
    return postApi(
      "/service/" + period.startDate + "/" + period.endDate,
      param,
    );
  },
  createService(param) {
    return postApi("/service", param);
  },
  updateService(param) {
    return putApi("/service/" + param.id, param);
  },
  deleteService(param) {
    return delApi("/service/" + param.id);
  },
  searchService(param) {
    return postApi("/service/search", param);
  },
  listServiceById(param) {
    return postApi("/service/id", param);
  },
  listNote(date_type, period) {
    return getApi(
      "/note/" + date_type + "/" + period.startDate + "/" + period.endDate,
    );
  },
  listNoteIn(customer_id, period) {
    return getApi(
      "/note/in/" + customer_id + "/" + period.startDate + "/" + period.endDate,
    );
  },
  listNoteOut(customer_id, period) {
    return getApi(
      "/note/out/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  listNoteRemain() {
    return getApi("/note/remain");
  },
  createNote(param) {
    return postApi("/note", param);
  },
  updateNote(param) {
    return putApi("/note/" + param.id, param);
  },
  deleteNote(param) {
    return delApi("/note/" + param.id);
  },
  listProductionsOfCustomer(param) {
    return getApi("/production/customer/" + param);
  },
  createProductionService(param) {
    return postApi("/production/service", param);
  },
  deleteProduction(param) {
    return postApi("/production/delete", param);
  },
  delete1Production(param) {
    return delApi("/production/" + param.id);
  },
  updateProduction(param) {
    return putApi("/production/" + param.id, param);
  },
  updateProductionStart(param) {
    return putApi("/production/start", param);
  },
  updateProductionResult(param) {
    return putApi("/production/result/" + param.id, param);
  },
  updateProductionFailure(param) {
    return putApi("/production/failure/" + param.id, param);
  },
  updateProductionFinish(param) {
    return putApi("/production/finish", param);
  },
  updateProductionPrint(param) {
    return getApi("/production/print/" + param.id);
  },
  listProductionTask(param) {
    return getApi("/production/task/" + param.id);
  },
  listSchedule(period, param) {
    return postApi(
      "/management/schedule/" + period.startDate + "/" + period.endDate,
      param,
    );
  },
  listHistoryTableId(table, id) {
    return getApi("/history/table_id/" + table + "/" + id);
  },
  listAccount() {
    return getApi("/account");
  },
  createAccount(param) {
    return postApi("/account", param);
  },
  updateAccount(param) {
    return putApi("/account/" + param.id, param);
  },
  deleteAccount(param) {
    return delApi("/account/" + param.id);
  },
  listConfig() {
    return getApi("/config");
  },
  updateConfig(param) {
    return putApi("/config/" + param.key, param);
  },
  listAssetCategory() {
    return getApi("/asset/category");
  },
  createAssetCategory(param) {
    return postApi("/asset/category", param);
  },
  updateAssetCategory(param) {
    return putApi("/asset/category/" + param.id, param);
  },
  deleteAssetCategory(param) {
    return delApi("/asset/category/" + param.id);
  },
  listAsset(period) {
    return getApi("/asset/" + period.startDate + "/" + period.endDate);
  },
  listAssetBalance(period) {
    return getApi("/asset/balance/" + period.startDate + "/" + period.endDate);
  },
  createAsset(param) {
    return postApi("/asset", param);
  },
  updateAsset(param) {
    return putApi("/asset/" + param.id, param);
  },
  deleteAsset(param) {
    return delApi("/asset/" + param.id);
  },
  statAssetSettlement(period) {
    return getApi("/asset/settlement/" + period.year + "/" + period.month);
  },
  statAssetEarningsSettlement(period) {
    return getApi(
      "/asset/earnings/settlement/" + period.year + "/" + period.month,
    );
  },
  statAssetMiscSettlement(period) {
    return getApi("/asset/misc/settlement/" + period.year + "/" + period.month);
  },
  listFailureProduction(param) {
    return getApi("/failure/production/" + param.id);
  },
  createFailure(param) {
    return postApi("/failure", param);
  },
  listScheduleUnion(period) {
    return getApi("/schedule/union/" + period.startDate + "/" + period.endDate);
  },
  createSchedule(param) {
    return postApi("/schedule", param);
  },
  updateSchedule(param) {
    return putApi("/schedule/" + param.id, param);
  },
  deleteSchedule(param) {
    return delApi("/schedule/" + param.id);
  },
  updateScheduleBulk(param) {
    return putApi("/schedule/bulk", param);
  },
  updateScheduleConfirm(param) {
    return putApi("/schedule/confirm", param);
  },
  updateScheduleConfirmCancel(param) {
    return putApi("/schedule/confirm_cancel", param);
  },
  listArea() {
    return getApi("/area");
  },
  listDetailArea(param) {
    return getApi("/area/" + param.id);
  },
  createArea(param) {
    return postApi("/area", param);
  },
  updateArea(param) {
    return putApi("/area/" + param.id, param);
  },
  deleteArea(param) {
    return delApi("/area/" + param.id);
  },
  selectIncomeCustomer(customer_id) {
    return getApi("/income/customer/" + customer_id);
  },
  selectIncomeCustomerDate(customer_id, date) {
    return getApi("/income/customer/" + customer_id + "/" + date);
  },
  listIncome(customer_id, period) {
    return getApi(
      "/income/" + customer_id + "/" + period.startDate + "/" + period.endDate,
    );
  },
  listIncomeCustomer(customer_id, period) {
    return getApi(
      "/income/customer/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  /** 아래 API 삭제 */
  listIncomeTransaction(param) {
    return getApi("/income/transaction/" + param.id);
  },
  registerIncomeTransaction(param) {
    return putApi("/income/transaction", param);
  },
  statIncome(period) {
    return getApi("/income/stat/" + period.startDate + "/" + period.endDate);
  },
  selectExpenseCustomerDate(customer_id, date) {
    return getApi("/expense/customer/" + customer_id + "/" + date);
  },
  listExpense(customer_id, period) {
    return getApi(
      "/expense/" + customer_id + "/" + period.startDate + "/" + period.endDate,
    );
  },
  listExpenseCustomer(customer_id, period) {
    return getApi(
      "/expense/customer/" +
        customer_id +
        "/" +
        period.startDate +
        "/" +
        period.endDate,
    );
  },
  statExpense(period) {
    return getApi("/expense/stat/" + period.startDate + "/" + period.endDate);
  },
  listBaseData() {
    return getApi("/base_data");
  },
  listGlassColor() {
    return getApi("/glass/color");
  },
  createGlassColor(param) {
    return postApi("/glass/color", param);
  },
  updateGlassColor(param) {
    return putApi("/glass/color/" + param.id, param);
  },
  deleteGlassColor(param) {
    return delApi("/glass/color/" + param.id);
  },
  listGlassThickness() {
    return getApi("/glass/thickness");
  },
  createGlassThickness(param) {
    return postApi("/glass/thickness", param);
  },
  updateGlassThickness(param) {
    return putApi("/glass/thickness/" + param.id, param);
  },
  deleteGlassThickness(param) {
    return delApi("/glass/thickness/" + param.id);
  },
  listDoorColor() {
    return getApi("/door/color");
  },
  createDoorColor(param) {
    return postApi("/door/color", param);
  },
  updateDoorColor(param) {
    return putApi("/door/color/" + param.id, param);
  },
  deleteDoorColor(param) {
    return delApi("/door/color/" + param.id);
  },
  updateGood(param) {
    return putApi("/good", param);
  },
  selectGoodSale(param) {
    return getApi("/good/sale/" + param);
  },
  listGoodCode(period) {
    return getApi("/good/" + period.startDate + "/" + period.endDate);
  },
  listBranch() {
    return getApi("/branch");
  },
  createBranch(param) {
    return postApi("/branch", param);
  },
  updateBranch(param) {
    return putApi("/branch/" + param.id, param);
  },
  deleteBranch(param) {
    return delApi("/branch/" + param.id);
  },
  listNotice(period) {
    return getApi("/notice/" + period.startDate + "/" + period.endDate);
  },
  listNoticeByUser(userId) {
    return getApi("/notice/" + userId);
  },
  createNotice(param) {
    return postApi("/notice", param);
  },
  updateNotice(param) {
    return putApi("/notice/" + param.id, param);
  },
  deleteNotice(param) {
    return delApi("/notice/" + param.id);
  },
  updateNoticeLog(param) {
    return getApi("/notice/log/" + param.id);
  },
  listLibrary(type_flag) {
    return getApi("/library/" + type_flag);
  },
  createLibrary(param) {
    return postApi("/library", param);
  },
  updateLibrary(param) {
    return putApi("/library/" + param.id, param);
  },
  deleteLibrary(param) {
    return delApi("/library/" + param.id);
  },
  listOption() {
    return getApi("/option");
  },
  createOption(param) {
    return postApi("/option", param);
  },
  updateOption(param) {
    return putApi("/option/" + param.id, param);
  },
  deleteOption(param) {
    return delApi("/option/" + param.id);
  },
  createSerial(idx) {
    return putApi("/serial/" + idx);
  },
  listSerialContractDetail(idx) {
    return getApi("/serial/contract_detail/" + idx);
  },
  listSerialAssigned(period) {
    return getApi(
      "/serial/assigned/" + period.startDate + "/" + period.endDate,
    );
  },
  listSerial(period) {
    return getApi("/serial/" + period.startDate + "/" + period.endDate);
  },
  replaceSerial(param) {
    return postApi("/serial/" + param.id, param);
  },
  sendSsoTicket() {
    return postApi("/sso/ticket");
  },
};
